import { render } from "./Policy.vue?vue&type=template&id=1d47d13b"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"

import "@/assets/css/layout_policy.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__